module.exports = __webpack_public_path__ + "static/media/retro-board-lp-header.07cde02c.svg";